export default __webpack_public_path__ + "static/media/land.dce5fdca.svg";